import { CertificateType } from '../../types';
import CertificateActions from './CertificateActions';

interface Props {
  studyPlanEnrollmentId: number;
  report: CertificateType;
}

export default function ReportActionsCell({
  studyPlanEnrollmentId,
  report,
}: Props) {
  const isDynamic = Boolean(report.dynamicFormId);

  return (
    <CertificateActions
      studyPlanEnrollmentId={studyPlanEnrollmentId}
      report={report}
      isDynamic={isDynamic}
    />
  );
}
